import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { path, prop } from 'ramda';

import { setDetails } from '@core/js/hooks/user/store/actions';

import { usePushSubscription } from 'js/hooks/socket/hooks/usePushSubscription';
import { useUserSelector } from 'js/store/hooks';

const ageStatusesToTest = ['failed', 'unknown'];

export const getIsUserVerified = (ageVerificationStatus) =>
    Boolean(ageVerificationStatus)
    && !ageStatusesToTest.includes(ageVerificationStatus);

export const useIsUserVerified = () => {
    const ageVerificationStatus = useUserSelector(path(['userDetails', 'ageVerificationStatus']));

    return useMemo(
        () => getIsUserVerified(ageVerificationStatus),
        [ageVerificationStatus]
    );
};

let isUserVerifiedLocal = null;

export const useSetIsUserVerified = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isUserVerified = useIsUserVerified();
    const ageVerificationStatus = useUserSelector(path(['userDetails', 'ageVerificationStatus']));

    useEffect(() => {
        if (typeof ageVerificationStatus === 'undefined' || !isLoggedIn) {
            isUserVerifiedLocal = null;
            return;
        }

        isUserVerifiedLocal = isUserVerified;
    }, [isUserVerified, isLoggedIn, ageVerificationStatus]);

    usePushSubscription(31133, () => pushMessage => {
        const { playerData } = pushMessage?.data?.action?.actionPlayerInfoChangeInfo || {};

        if (playerData) {
            dispatch(setDetails(playerData));
        }
    });
};

export const getIsUserVerifiedLocal = () => isUserVerifiedLocal;
